/* eslint-disable */
import React from 'react';
import { read } from 'xlsx';
import Extractor from '../utils/Extractor';

export default class DropzoneComponent extends React.Component {
  constructor(props) {
    super(props);
    this.dropzone = React.createRef();

    this.state = {
      loading: false,
      error: null,
      extractError: null,
      headerError: null,
      filename: null,
      statusMessage: null
    }
  }

  handleFile = async (file) => {
    // Create a new File object with the cleaned name
    const cleanName = file.name.replace(/\+/g, "_");
    const renamedFile = new File([file], cleanName, {
      type: file.type,
      lastModified: file.lastModified,
    });

    this.setState({
      filename: cleanName,
      loading: true,
    })

    const { id, headers, error, message } = await this.postFile(renamedFile);
    if (error) {
      this.setState({ error: message, loading: false });
      return;
    } 

    this.fduId = id;
    this.setState({ statusMessage: 'Scanning file for threats…' });
    const scanResult = await this.pollScanStatus(id);

    if (!scanResult.success) {
      this.setState({ 
        error: scanResult.error, 
        loading: false, 
        statusMessage: null
      });
      return;
    }

    this.setState({ statusMessage: null });
    this.readFile(renamedFile, headers);
  }

  handleComplete = (fdu) => {
    this.setState({ loading: false });
    this.props.notify(`${JSON.parse(fdu.document)} uploaded for ${this.props.name}. You’ll be notified when the reports are ready to view or you can go ahead and map it.`);
    this.props.addFdu(fdu);
  }

  handleExtractError = (error) => {
    if (error) {
      this.setState({ extractError: 'Could not extract rows. Please remove any formatting, extra rows, and check that your headers columns match the values.' })
    }
  }

  handleHeaderError = (missingCols) => {
    this.setState({
      headerError: 'Missing Headers: ' + missingCols.join(', '),
    })
  }

  readFile = (file, headers = null) => {
    const { id, financialReportType, calendarYearEnd, fiscalYearEnd } = this.props;
    const { handleHeaderError, handleComplete, handleExtractError, fduId } = this;
    const reader = new FileReader();
    reader.onload = function (e) {

      const data = new Uint8Array(e.target.result);
      const workbook = read(data, { type: 'array' });

      const extractor = new Extractor({
        workbook,
        headers,
        fduId,
        clientId: id,
        financialReportType: financialReportType,
        calendarYearEnd: calendarYearEnd,
        fiscalYearEnd: fiscalYearEnd
      });

      extractor.onComplete = handleComplete;
      extractor.onHeaderError = handleHeaderError;
      extractor.onExtractError = handleExtractError;
      extractor.extract();
    };

    reader.readAsArrayBuffer(file);
  }

  postFile = async (file) => {
    const formData = new FormData();
    formData.append('attachment[document]', file);
    formData.append('attachment[company_id]', this.props.id);
    formData.append('attachment[financial_report_type]', this.props.financialReportType)

    const response = await fetch('/api/v1/financial_data_uploads', {
      headers: { 'X-CSRF-Token': window.token },
      method: 'POST',
      body: formData
    })
    const fdu = await response.json();
    return fdu;
  }

  // Waiting for file scan from AWS
  pollScanStatus = async (fduId) => {
    const MAX_ATTEMPTS = 24;  // 24 × 5s = 2 minutes
    const INTERVAL_MS  = 5000;

    for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
      await new Promise(resolve => setTimeout(resolve, INTERVAL_MS));

      const response = await fetch(`/api/v1/financial_data_uploads/${fduId}/scan_status`, {
        headers: { 'X-CSRF-Token': window.token }
      });

      if (!response.ok) {
        return { success: false, error: 'Unable to check file scan status. Please try again.' };
      }

      const data = await response.json();
      
      switch (data.scan_status) {
        case 'safe':
          return { success: true };
        case 'infected':
          return { success: false, error: 'This file was rejected because a threat was detected. Please contact support if you need help.' };
        case 'scan_error':
          return { success: false, error: 'The file could not be scanned. Please try again or contact support.' };
        default:
          // status 'pending' or null — keep polling
          continue;
      }
    }

    return { success: false, error: 'Scan timed out. Please try again or contact support.' };
  }

  onDragOver = (e) => {
    document.getElementById(`dropzone-${this.props.id}`).style.background = '#e6e6e6';
    e.preventDefault();
  }

  onDragLeave = () => {
    document.getElementById(`dropzone-${this.props.id}`).style.background = 'white';
  }

  onDrop = (e) => {
    e.preventDefault();
    document.getElementById(`dropzone-${this.props.id}`).style.background = 'white';
    this.handleFile(e.dataTransfer.files[0])
  }

  addFile = (e) => {
    this.handleFile(e.target.files[0])
  }

  render() {
    const { error, extractError, headerError, loading, filename, statusMessage } = this.state;
    if (error) {
      return (
        <div className='dropzone dropzone-error'>
          {error}
        </div>
      )
    }

    if (headerError) {
      return (
        <div className='dropzone dropzone-header-error'>
          {headerError}
          <div>
            <a href={this.props.hrefBuilder(this.props.subdomain, `/financial_data_uploads/${this.fduId}/edit`)}>Help Us Find Them</a>
          </div>
        </div>
      )
    }

    if (extractError) {
      return (
        <div className='dropzone dropzone-error'>
          {extractError}
          <div>
            <div>Check The File's Rows, Close & Open This Client's Details Pop-up and Re-Upload.</div>
          </div>
        </div>
      )
    }

    if (loading) {
      return (
        <div className='dropzone dropzone-loading'>
          {statusMessage ? statusMessage : `Processing ${filename}`}
        </div>
      )
    }

    if (error === null && extractError === null && headerError === null && filename !== null && loading === false && statusMessage === null) {
      let uploadMessage = this.props.financialReportType === "trial_balance" ? "Upload Another File" : this.props.financialReportType === "pnl" ? "Upload Another P&L" : "Upload Another Balance Sheet"
      return (
        <label className='modal-import-section green-background-btn' htmlFor={`file-upload-${this.props.id}-${this.props.financialReportType}`}>
          <input id={`file-upload-${this.props.id}-${this.props.financialReportType}`} className='file-upload-input' type='file' onChange={this.addFile} />
          <span>{uploadMessage}</span>
        </label>
      )
    }

    return (
      <label className='import-file-modal-btn modal-import-section green-background-btn' htmlFor={`file-upload-${this.props.id}-${this.props.financialReportType}`}>
        <input id={`file-upload-${this.props.id}-${this.props.financialReportType}`} className='file-upload-input' type='file' onChange={this.addFile} />
        <span>{this.props.financialReportType === "trial_balance" ? "Click to Import Trial Balance" : this.props.financialReportType === "pnl" ? "Import P&L" : "Import Balance Sheet"}</span>
      </label>
    )
  }
}
